import { ColumnDefinitionType } from "./Table";
import React from "react";

type TableHeaderProps<T, K extends keyof T> = {
  columns: Array<ColumnDefinitionType<T, K>>;
  addRow: () => void;
  showRowActions: boolean;
  hideColumns?: boolean 
};

const TableHeader = <T, K extends keyof T>({
  columns,
  addRow,
  showRowActions,
  hideColumns
}: TableHeaderProps<T, K>): JSX.Element => {
  const tableHeadTrClassName = "border-b border-sk-tertiary-blue";
  const headers = columns.map((column, index) => {
    const tableHeadClassName = "text-2xl font-thin";
    return (
      <th
        colSpan={column.colSpan}
        key={`headCell-${index}`}
        className={
          column.header === "Beskrivelse" ||
          column.isWide
            ? tableHeadClassName
            : tableHeadClassName + " xl:w-4/12"
        }
      >
        {column.header}
      </th>
    );
  });

  return (
    <thead>
      <tr className={tableHeadTrClassName}>
        {hideColumns !== true && headers}
        {showRowActions && (
          <th className="last:w-1/12 font-thin ml-4 items-center text-gray-700 p-5 cursor-pointer">
            <button
              type="button"
              onClick={addRow}
              className="flex flex-col items-center transition duration-500 ease-in-out
                              transform hover:-translate-y-1 hover:scale-110 mx-auto"
            >
              <svg className="w-10 h-10 " viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
                />
              </svg>
              <p>Ny rad</p>
            </button>
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
